@let person = mitarbeiter();
<soft-ds-card
  class="mitarbeiter-card"
  density="compact"
  [accent]="accent()"
  [chevron]="mode() === 'display'"
  (click)="tapped.emit()"
  data-testid="mitarbeiter-card"
>
  <soft-ds-card-header>
    <soft-ds-card-title>
      {{ person.lstfix.persnr }} - {{ person.lstfix.vorname }} {{ person.lstfix.zuname }}
    </soft-ds-card-title>
    @if (hasDetails()) {
      <soft-ds-card-description>
        <div class="mitarbeiter-card__details">
          @if (person.letzterStempel; as stamp) {
            <div>
              {{ stamp.kzkg === 'K' ? 'Kommt' : 'Geht' }} um
              {{ stamp.zeit | format: 'TIME.DEFAULT' }}
            </div>
          }
          @if (person.aktuellerTermin; as appointment) {
            <div>
              {{ appointment.vonzeit | format: 'TIME.DEFAULT' }} -
              {{ appointment.biszeit | format: 'TIME.DEFAULT' }}
              {{ appointment.taetigkeit }}
            </div>
          }
          @if (person.aktuellerDpEintrag; as entry) {
            <div>
              {{ entry.vonzeit | format: 'TIME.DEFAULT' }} -
              {{ entry.biszeit | format: 'TIME.DEFAULT' }}
              {{ entry.taetigkeit }}
            </div>
          }
          @if (isOnVacation()) {
            <div>
              {{ person.abwesenheit?.bezeichnung }} bis
              {{ person.abwesenheit?.bisdatum | format: 'DATE.DEFAULT' }}
            </div>
          }
        </div>
      </soft-ds-card-description>
    }
    @if (isSelected()) {
      <soft-ds-card-trailing align="center">
        <soft-ds-icon name="fa-solid fa-circle-check" color="brand" size="lg" />
      </soft-ds-card-trailing>
    }
  </soft-ds-card-header>
</soft-ds-card>
